export default function safeImageUrl(maybeUrl) {
  return window.encodeURI(maybeUrl || "https://placehold.co/300?text=No Image");
}
